import React, { useReducer, useCallback } from "react";
import { Context, INIT_STATE } from "../../common/js/constant";
import Reducers from "../../common/reducers";
import { wrapperDispatch } from "../../common/js/util";

export default function ContextProvider(props) {
  const [state, dispatch] = useReducer(Reducers, INIT_STATE);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myDispatch = useCallback(wrapperDispatch(dispatch), []);

  return (
    <Context.Provider
      value={{
        state,
        dispatch: myDispatch,
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
